import { createSlice } from '@reduxjs/toolkit';

export interface RedirectionBannerState {
    isVisible: boolean;
    doNotShowAgain: boolean;
}

const initialState: RedirectionBannerState = {
    isVisible: false,
    doNotShowAgain: false,
};

export const redirectionBannerSlice = createSlice({
    name: 'redirectionBanner',
    initialState,
    reducers: {
        setIsRedirectionBannerVisible: (state, action) => {
            if (!state.doNotShowAgain) {
                state.isVisible = action.payload;
            }
        },
        setDoNotShowAgain: state => {
            state.doNotShowAgain = true;
            state.isVisible = false;
        },
    },
});

export const { setIsRedirectionBannerVisible, setDoNotShowAgain } = redirectionBannerSlice.actions;

export default redirectionBannerSlice.reducer;
